<template>
  <v-dialog v-model="dialog" width="700">
    <v-card rounded="lg">
      <v-card-title>
        Rescindir contrato

        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text class="text--primary">
        <v-card class="mb-3 rounded-lg grey lighten-4" flat>
          <v-card-text class="text--primary body-1">
            <div>
              En caso de ser necesario, ingrese el monto correspondiente a la
              rescisión anticipada.
            </div>

            <div class="d-flex flex-row" style="gap: 12px">
              <v-text-field
                v-model="attributes.rent"
                type="number"
                label="Monto"
                outlined
                class="rounded-lg mt-2"
                style="width: calc(100%/3)"
                dense
                persistent-hint
                hint="Los honorarios de administración aplicarán sobre este monto."
              ></v-text-field>

              <v-text-field
                v-model="attributes.bonification"
                type="number"
                label="Monto bonificado"
                style="width: calc(100%/3)"
                outlined
                class="rounded-lg mt-2"
                dense
              ></v-text-field>

              <v-text-field
                v-model="attributes.quota"
                :rules="[v => v > 0 || 'Debe ser mayor a cero.']"
                type="number"
                label="Cuotas"
                style="width: calc(100%/3)"
                outlined
                class="rounded-lg mt-2"
                dense
              ></v-text-field>
            </div>
          </v-card-text>
        </v-card>

        <div
          v-if="
            attributes.receiptAttributes.paymentsAttributes &&
              attributes.receiptAttributes.paymentsAttributes.length
          "
        >
          <v-row
            style="width: 100%"
            class="grey lighten-4 rounded-lg caption text-uppercase ml-0"
          >
            <v-col cols="4">
              Concepto
            </v-col>

            <v-col cols="4">
              Forma de pago
            </v-col>

            <v-col cols="3" class="text-right">
              Monto
            </v-col>
          </v-row>

          <template
            v-for="(payment, i) in attributes.receiptAttributes
              .paymentsAttributes"
          >
            <v-row
              class="ml-0"
              style="width: 100%; border-bottom: 1px solid #dedede"
            >
              <v-col cols="4">
                {{ payment.concept }}
              </v-col>

              <v-col cols="4">
                {{ payment.paymentType }}
              </v-col>

              <v-col cols="3" class="text-right">
                {{ payment.amount }}
              </v-col>

              <v-col cols="1" class="text-right">
                <v-icon
                  @click="removePayment(i, payment)"
                  color="error lighten-2"
                  class="mt-n1"
                >
                  mdi-delete
                </v-icon>
              </v-col>
            </v-row>
          </template>
        </div>

        <div v-else>
          <v-card flat color="grey lighten-4" class="rounded-lg">
            <v-card-text class="text--primary">
              Aquí se listarán los pagos relacionados a rescindir el contrato.
            </v-card-text>
          </v-card>
        </div>

        <div class="text-right mt-3">
          <create :contract="contract" @created="pushPayment"></create>
        </div>

        <div style="gap: 12px" class="justify-end d-flex flex-row mt-3">
          <v-btn
            v-if="contract.state != 'finished'"
            depressed
            @click="finishContract"
            color="error"
            outlined
          >
            Confirmar y rescindir
          </v-btn>

          <v-btn depressed @click="createReceipt" color="primary" outlined>
            Guardar y continuar luego
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { FinishContract } from "@/graphql/mutations/contracts";
import { DeletePayment } from "@/graphql/mutations/payments";
import {
  Create as CreateRescission,
  EditRescission
} from "@/graphql/mutations/rescissions";

import Create from "@/components/payments/general/Create";
import Card from "@/components/payments/general/Card";

export default {
  data: () => ({
    dialog: false,
    modal: false,
    loading: false,
    attributes: {
      contractId: null,
      rent: 0,
      state: "draft",
      quota: 1,
      bonification: 0,
      receiptAttributes: {
        id: null,
        state: "pending",
        receiptType: "tenant",
        userId: null,
        contractId: null,
        paymentsAttributes: []
      }
    }
  }),

  props: {
    contract: {
      type: Object,
      required: true
    },
    open: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  created() {
    if (this.open) this.dialog = true;

    if (this.contract.rescission) {
      Object.keys(this.attributes).forEach(k => {
        if (k !== "receiptAttributes")
          this.attributes[k] = this.contract.rescission[k];
      });

      Object.keys(this.attributes.receiptAttributes).forEach(k => {
        if (k !== "paymentsAttributes")
          this.attributes.receiptAttributes[
            k
          ] = this.contract.rescission.receipt[k];
      });

      this.contract.rescission.receipt.payments.forEach(payment => {
        if (payment.concept !== "Alquiler")
          this.attributes.receiptAttributes.paymentsAttributes.push({
            id: payment.id,
            concept: payment.concept,
            amount: payment.amount
          });
      });
    } else {
      this.attributes.receiptAttributes.userId = this.contract.tenant[0].id;
      this.attributes.receiptAttributes.contractId = this.contract.id;
      this.attributes.contractId = this.contract.id;
    }
  },

  watch: {
    open() {
      this.dialog = this.open;
    }
  },

  methods: {
    finishContract() {
      this.loading = true;

      this.attributes.state = "confirmed";

      if (!this.attributes.dueAt || this.attributes.dueAt <= new Date()) {
        this.$apollo
          .mutate({
            mutation: FinishContract,
            variables: {
              input: {
                id: this.contract.id
              }
            }
          })
          .then(res => {
            this.createReceipt();
          });
      } else {
        this.createReceipt();
      }
    },

    createReceipt() {
      if (this.contract.rescission) {
        this.$apollo
          .mutate({
            mutation: EditRescission,
            variables: {
              input: {
                id: this.contract.rescission.id,
                attributes: this.attributes
              }
            }
          })
          .then(res => {
            this.$router.go();
          });
      } else {
        this.$apollo
          .mutate({
            mutation: CreateRescission,
            variables: {
              input: {
                attributes: this.attributes
              }
            }
          })
          .then(res => {
            this.$router.go();
          });
      }
    },

    pushPayment(payment) {
      payment.contractId = this.contract.id;
      this.attributes.receiptAttributes.paymentsAttributes.push(payment);
    },

    removePayment(idx, payment) {
      if (payment.id) {
        this.$apollo.mutate({
          mutation: DeletePayment,
          variables: {
            input: {
              paymentId: payment.id
            }
          }
        });
      }

      this.attributes.receiptAttributes.paymentsAttributes.splice(idx, 1);
    }
  },

  components: {
    Create,
    Card
  }
};
</script>
